<template>
  <button :class="['lk-btn', small ? 'lk-btn-sm' : '']" @click="copy">
    {{ copied ? '✓ Copied' : label }}
  </button>
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    text: { type: String, required: true },
    label: { type: String, default: '⧉ Copy' },
    small: { type: Boolean, default: false },
  },
  data() {
    return { copied: false, timer: null };
  },
  methods: {
    copy() {
      try { navigator.clipboard.writeText(this.text); } catch (e) { /* ignore */ }
      this.copied = true;
      this.$emit('copied');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.copied = false; }, 1500);
    },
  },
  beforeUnmount() { clearTimeout(this.timer); },
};
</script>
